import type { Npc, Relationship } from '../../types.js';
import type { WorldState } from '../useSim.js';
import { appendNpcToWorldState } from './appendNpc.js';

export function appendLiveNpc(
  npc: Npc,
  npcsRef: { current: Npc[] },
  worldRef: { current: WorldState | null },
  relationships: Map<string, Relationship>,
  setNpcs: (npcs: Npc[]) => void,
): void {
  const added = appendNpcToWorldState(npcsRef.current, worldRef.current, relationships, npc);
  npcsRef.current = added.npcs;
  worldRef.current = added.world;
  setNpcs(added.npcs);
}
